import { AxiosInstance } from 'axios';

import * as types from '../../../../../../../typings/api/integrations/xsite/rest/v1/skymap-xsite-connection';

export class SkyMapXsiteConnectionServiceV1 implements types.Handlers {
  private readonly endpoint = '/v1/skymap-xsite-connection';

  constructor(private axios: AxiosInstance) {}

  async getSkyMapXsiteConnection(
    params: types.GetSkyMapXsiteConnectionParameters,
  ): Promise<types.GetSkyMapXsiteConnectionResponse> {
    return (await this.axios.get(`${this.endpoint}`, { params: params.query })).data;
  }

  async deleteSkyMapXsiteConnection(
    params: types.DeleteSkyMapXsiteConnectionParameters,
  ): Promise<void> {
    return (
      await this.axios.delete(`${this.endpoint}/${params.path.skyMapXsiteConnectionId}`, {
        params: params.query,
      })
    ).data;
  }

  async getSkyMapXsiteConnectionStatus(
    params: types.GetSkyMapXsiteConnectionStatusParameters,
  ): Promise<types.GetSkyMapXsiteConnectionStatusResponse> {
    return (await this.axios.get(`${this.endpoint}/status`, { params: params.query })).data;
  }

  async getAsbuiltPoints(
    params: types.GetAsbuiltPointsParameters,
  ): Promise<types.GetAsbuiltPointsResponse> {
    return (
      await this.axios.get(`${this.endpoint}/${params.path.skyMapXsiteConnectionId}/asbuilt`, {
        params: params.query,
      })
    ).data;
  }
}
